import { render, staticRenderFns } from "./categories-filter.vue?vue&type=template&id=1d9e80e9&"
import script from "./categories-filter.vue?vue&type=script&lang=ts&"
export * from "./categories-filter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports